export default function importevent() {
    const self = {}

    return self
}



// WEBPACK FOOTER //
// ./src/components/importexcel/importevent.js